<template>
  <div class="theCookieNotice">
    <div class="campl-cookie-banner-text">
      This website requires essential cookies to deliver services.
      <a
        href="http://www.lib.cam.ac.uk/privacy-policy"
        target="_blank"
      >Learn more</a>.
    </div>
  </div>
</template>


<style scoped>
.theCookieNotice {
  position: fixed;
  bottom: 5rem;
  right: 3rem;
  background: white;
  padding: 0.5rem 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  z-index: 9999;
}
</style>
